import React, { useState, memo, useEffect } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MainButton from "../../shared/Button";
import { IconButtonMain, DialogMain } from "../accounting/styles/DialogStyles";
import { OrderDriverPopupMain } from "./styles/AssignOrderDriverPopupStyle";
import { PermissionsMain } from "../agents/styles/NewUserPopupStyle";
import SelectPermissions from "../agents/SelectPermissions";
import {
  AssignBroadcastOrdeds,
  GetAllDriversList,
} from "../../../services/admin/dispatche";
import { toast } from "react-hot-toast";
import SelectDropDown from "../shared/SelectDropDown";

const AssignOrderDriverPopup = ({
  open,
  handleClose = () => {},
  SelectedRow = {},
}) => {
  const [loading, setLoading] = useState(false);
  const [Btnloading, setBtnLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [amount, setamount] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsValue, setselectedOptionsValue] = useState([]);

  useEffect(() => {
    if (open) {
      handleFetchAllDrivers();
    }
  }, [open]);

  const handleFetchAllDrivers = async () => {
    const resp = await GetAllDriversList(setLoading);
    if (resp?.status === 200 && resp?.data?.message === "Success") {
      const formattedOptions = resp?.data?.data?.map((item) => ({
        value: item?.slug,
        label: item?.name,
      }));
      setOptions(formattedOptions);
    }
  };

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);

    // Check if "Select All" option is selected

    // const selectAllOption = options.find(
    //   (option) => option.value === "select-all"
    // );
    // if (selectedOptions?.some((option) => option.value === "select-all")) {
    //   // Select or deselect all options based on the "Select All" checkbox
    //   setSelectedOptions(
    //     selectedOptions.length === options.length ? [] : options
    //   );
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount) {
      toast.error("Amount is required.");
      return;
    }
    if (parseFloat(amount) < 0) {
      toast.error("Please enter a valid non-negative number.");
      return;
    }
    if (selectedOptions.length === 0) {
      toast.error("Please select at least one option.");
      return;
    }

    // const selectedOptionIds = selectedOptions
    //   .map((option) => option.value)
    //   .join(",");
    // If all validations pass, proceed with the submission

    const DataObj = {
      type: "driver",
      driver_amount: amount,
      driver_id: selectedOptions?.value,
    };
    const respon = await AssignBroadcastOrdeds(
      setBtnLoading,
      SelectedRow?.order_id,
      DataObj
    );

    if (respon.status === 200) {
      toast.success("Successfully Assigned!");
      setSelectedOptions([]);
      setamount("");
    }
  };

  // const selectAllOption = {
  //   value: "select-all",
  //   label: "Select All",
  // };
  // const selectOptions = [selectAllOption, ...options];

  // Check if amount and selectedOptions are empty to disable the submit button
  const isSubmitDisabled = amount === "" || selectedOptions.length === 0;

  return (
    <>
      <DialogMain open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6>Assign Order To Driver</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleClose}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <OrderDriverPopupMain>
            <form onSubmit={handleSubmit}>
              <input
                type="number"
                placeholder="Enter amount"
                onChange={(e) => setamount(e.target.value)}
                value={amount}
              />
              <PermissionsMain>
                {/* <SelectPermissions
                  options={options}
                  selectedOption={selectedOptions}
                  handleChange={handleChange}
                  name="permissions"
                  placeholder="Select Driver"
                  isMulti={false}
                /> */}

                <SelectDropDown
                  options={options}
                  selectedOption={selectedOptions}
                  handleChange={handleChange}
                  placeholder="Select Driver"
                />
              </PermissionsMain>
              <MainButton
                type="submit"
                label="Assign Order"
                disabled={isSubmitDisabled}
                isLoading={Btnloading}
              />
            </form>
          </OrderDriverPopupMain>
        </DialogContent>
      </DialogMain>
    </>
  );
};

export default memo(AssignOrderDriverPopup);
